import Scoreapis  from "../../api/score";
import ScoreModel from "../OnlineDetail/index.vue";
import ScoreModel2 from "../OnlineBank/index.vue";
export default {
    name: "ScoreList",
    components: {
      ScoreModel,
      ScoreModel2
    },
    data() {
        return {
            detailVisible:false,
            dataDetail:{},
            userList:[],
            type:"",
            query: {
                keyword: "",
                state:"1",
                pageIndex: 1,
                pageSize: 10
            },
            tableCols:[
                {
                  "prop": "PersonCompanyText",
                  "label": "申请者",
                  "width": "",
                  "align": "center"
              },
              {
                "prop": "BankName",
                "label": "银行",
                "width": "",
                "align": "center"
            },
              {
                  "prop": "Money",
                  "label": "申请金额/万元",
                  "width": "160",
                  "align": "center"
              },
              {
                  "prop": "FinalMoney2",
                  "label": "审批金额/万元",
                  "width": "160",
                  "align": "center"
              },
              {
                "prop": "State",
                "label": "当前节点",
                "width": "140",
                "align": "center"
              },
              {
                  "prop": "UpdateTime",
                  "label": "最后更新时间",
                  "width": "160",
                  "align": "center"
              },
                {
                    "prop": "Operation",
                    "label": "操作",
                    "width": "240",
                    "align": "center"
                }
            ],
            tableData:[],
            statelist:["","待审核","已担保审核","已拒绝","银行通过","银行未通过"],
            pageTotal: 0,
            scrollHeight:400,
            tel:""
        };
    },
    beforeCreate: function () {
      let meta = this.$route.meta
      if(meta&&meta.permBtns.length>0){
        this.permBtns = meta.permBtns
      }
  },
    created() {
      this.getData();
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    // watch: {
    //   dataDetail: {
    //     handler(newVal) {
    //       this.tel=newVal.UserID
    //       var userList=this.userList;
    //       for(var i=0;i<userList.length;i++)
    //       if(userList[i].UserID==newVal.UserID){
    //         var tel=userList[i].Tel;
    //         this.tel=tel;
    //       }
    //      },
    //      deep: true,
    //   }
    // },
    methods: {
        getData(){
          let param=this.query;
          var that=this;
          Scoreapis.getApplyOnlineList(param).then(res => {
            that.tableData=res.list;
            if(that.tableData&&that.tableData.length>0){
              for(let i=0;i<that.tableData.length;i++){
                if(that.tableData[i].FinalMoney&&that.tableData[i].FinalMoney!==0){
                  that.tableData[i].FinalMoney2 = that.tableData[i].FinalMoney*1.0/1000000
                }
              }
            }
            this.$data.pageTotal=res.count
                    });
    
      },
      bankAuditSucess(){
        this.getData();
      },
      AddSucess(){
        this.getData();
      },
      selectUser(){
      var UserID=this.dataDetail.UserID;
      if(UserID==''){
        this.tel="";return;
      }
      var userList=this.userList;
          for(var i=0;i<userList.length;i++)
          if(userList[i].UserID==UserID){
            var tel=userList[i].Tel;
            this.tel=tel;
          }
      },
      getScoreById(){
          let param={
            ScoreId: "1"
          };
         Scoreapis.getScoreById(param).then(res => {
                            this.$data.form=res;
                    });
      },
      addOrUpdateScore(){
          let param=this.$data.dataDetail;
          if(param.UserName==""){
            this.$message.error("姓名不能为空");
            return;
          }
          if(this.type=="add")this.addScore(param);
          else this.updateScore(param);
      
      },
      addScore(param){
        Scoreapis.addScore(param).then(res => {
          if(res){
           this.$message.success("新增成功");
             this.getData();
             this.$data.detailVisible=false;
          }else{
            this.$message.error("新增失败");
          }
      });
      },
       updateScore(param){
         Scoreapis.updateScore(param).then(res => {
                        if(res){
                         this.$message.success("修改成功");
                           this.getData();
                           this.$data.detailVisible=false;
                        }else{
                          this.$message.error("修改失败");
                        }
                    });
      },
        // 触发搜索按钮
        refreshList() {
            this.query.pageIndex = 1;
            this.getData();
        },
        getUserList(user){
          let param={
            type:"0",
            keyword:""
          }
          Scoreapis.getUserListByMenuId(param).then(res => {
            if(user)res.push(user);
            this.userList=res;
        });
        },
        handleEmpty(){
           this.$data.query={
            keyword: "",
            state:"1",
            pageIndex: 1,
            pageSize: 10}
        },
        handleAdd(){
          var that=this;
          that.$refs.ScoreModel.onChangeOpen()
          that.$refs.ScoreModel.queryData({},"add")
          // this.$data.detailVisible=true;
          // this.dataDetail={
          //   UserName:"",
          // }
          // this.type="add";
        },
        handleUpdate(index, row){
          var that=this;
          that.$refs.ScoreModel.onChangeOpen()
          that.$refs.ScoreModel.queryData(row,"update")
        },
        handleBankUpdate(index, row){
          var that=this;
          that.$refs.ScoreModel2.onChangeOpen()
          that.$refs.ScoreModel2.queryData(row,"update")
        },
        handleView(index, row){
          var that=this;
          that.$refs.ScoreModel.onChangeOpen()
          that.$refs.ScoreModel.queryData(row,"info")
        },
        // 删除操作
        handleDelete(index, row) {
            let that = this;
            if(row){
                that.$confirm('确定删除吗, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                  let param={
                    Id:row.Id
                  };
                 Scoreapis.deleteScore(param).then(res => {
                                if(res){
                                  that.$message.success("删除成功");
                                  that.getData();
                                }else{
                                  that.$message.error("删除失败");
                                }
                            });
                }).catch(() => {
                  that.$message({
                      type: 'info',
                      message: '已取消删除'
                    });
                });
            }
        },
        // 分页导航
        handlePageChange(val) {
            this.query.pageIndex = val;
            this.getData();
        },
        handleSizeChange(val){
            this.query.pageIndex = 1;
            this.query.pageSize = val;
            this.getData();
        },
        calcTableHeight(){
          this.$nextTick(() => {
            var height1=$(".content-box .content").height();
            var height2=$(".content-box .content .seach-container").height();
            var height=height1-height2-112-40;
            this.scrollHeight = height;
          });
        }
    },
  
  };
